export const breadcrumbList = [
  {
    name: '员工管理',
    path: ''
  },
  {
    name: '部门管理',
    path: ''
  }
]
